import { createDialog } from "./createDialog";

export interface ConfirmOptions {
  message: string;
  title?: string;
  html?: boolean;
}

export async function confirmDialog(message: string): Promise<boolean>;
export async function confirmDialog(message: string, title?: string): Promise<boolean>;
export async function confirmDialog(
  message: string,
  options: Omit<ConfirmOptions, "message">,
): Promise<boolean>;
export async function confirmDialog(options: ConfirmOptions): Promise<boolean>;
export function confirmDialog(
  message: string | ConfirmOptions,
  options?: string | Omit<ConfirmOptions, "message">,
): Promise<boolean> {
  if (typeof message === "object") {
    [options, message] = [message, message.message];
  }
  if (typeof options === "string") {
    options = { title: options };
  }

  const [dialog, content] = createDialog(options?.title ?? "Confirm", {
    autoOpen: true,
    noCloseButton: true,
  });

  const buttonRow = dialog.querySelector("div.button-row")!;
  buttonRow.innerHTML = `
    <form method="dialog">
      <button type="submit" class="button button-color-negative" name="confiremd" value="No" autofocus>
        No
      </button>
      
      <button type="submit" class="button button-color-positive" name="confirmed" value="Yes">
        Yes
      </button>
    </form>
    `;

  if (options?.html) {
    content.innerHTML = message;
  } else {
    content.innerText = message;
  }

  return new Promise((resolve, reject) => {
    // When the form submits, `submit` is raised followed by `close`.
    dialog.addEventListener(
      "submit",
      (e) => resolve(e.submitter instanceof HTMLButtonElement && e.submitter.value === "Yes"),
      true,
    );

    // Cancel is universally recognized as a negative response.
    dialog.addEventListener("cancel", () => resolve(false), { once: true });

    // In case of error event, though I don't know what would raise this.
    dialog.addEventListener(
      "error",
      (e) => reject(new Error("The dialog raised an error.", { cause: e })),
      { once: true },
    );

    // In case the dialog is closed unexpectedly.
    dialog.addEventListener(
      "close",
      () => {
        if (dialog.returnValue === "Yes") {
          resolve(true);
        } else if (dialog.returnValue === "No") {
          resolve(false);
        } else {
          reject(new Error("The confirmation dialog was not answered."));
        }
      },
      { once: true },
    );
  });
}
